import { SvgIcon, useTheme } from '@mui/material';
import { FC } from 'react';
import ArrowRightIcon from '../../../../../icons/svg/arrow_right.svg?react';
import ArrowUpIcon from '../../../../../icons/svg/arrow_up.svg?react';

type Props = {
  open: boolean;
};

export const SubmenuIndicator: FC<Props> = ({ open }) => {
  const theme = useTheme();

  return (
    <SvgIcon component={open ? ArrowUpIcon : ArrowRightIcon} htmlColor={theme.palette.grey[900]} />
  );
};
